import axios from 'axios'
import * as utils from './apiUtils'

export default {
  index(obj) {
    return axios.get(utils.getApiUrl('/emergency_contact_reports'), {
      params: obj || {}
    })
  },
  create({ data }) {
    return axios.post(utils.getApiUrl('/emergency_contact_reports'), data)
  },
  show({ id }) {
    return axios.get(utils.getApiUrl(`/emergency_contact_reports/${id}`))
  },
  update({ id, data }) {
    return axios.put(utils.getApiUrl(`/emergency_contact_reports/${id}`), data)
  },
  delete({ id }) {
    return axios.delete(utils.getApiUrl(`/emergency_contact_reports/${id}`))
  },
  addPhotos({ id, formData }) {
    return axios.post(utils.getApiUrl(`/emergency_contact_reports/${id}/photos`), formData)
  },
  updatePhotos({ id, data }) {
    return axios.patch(utils.getApiUrl(`/emergency_contact_reports/${id}/photos`), data)
  },
  deletePhoto({ id, photo }) {
    return axios.delete(utils.getApiUrl(`/emergency_contact_reports/${id}/photos/${photo.id}`))
  },
  downloadCSV({ data }) {
    return axios.get('/emergency_contact_reports/download_csv.csv', {
      params: data,
      responseType: 'blob',
    })
  },
}
